import { initializeArticleSlider } from '../../shared/articles-slider';
import { setUpGeolocation } from './browserGeolocation';
import { setUpModals } from '../../shared/controllers/modalController';
import tippy, { followCursor } from 'tippy.js';

import '../../shared/controllers/scrollSpyController';
import '../../b2c/directory/bookableTimes';
import '../../b2c/directory/nonApiBookableTimes';
import '../../shared/controllers/autocompleteController';
import '../../shared/controllers/slideOutController';
import '../../shared/controllers/expansionController';

// set up article slider

const articleSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 4,
  slideWidth: 248,
  gap: 24,
  peek: {
    before: 48,
    after: 0,
  },
  breakpoints: {
    1024: {
      perView: 3,
      peek: {
        before: 48,
        after: 40,
      },
    },
    650: {
      perView: 2,
      peek: {
        before: 48,
        after: 0,
      },
    },
    450: {
      perView: 1,
      peek: {
        before: 48,
        after: 0,
      },
    },
  },
};

const articleSliderSelector = '.directory-featured-articles.glide';
if (articleSliderSelector) {
  initializeArticleSlider(articleSliderSelector, articleSliderOptions);
}
initializeArticleSlider(articleSliderSelector, articleSliderOptions);

setUpGeolocation();
setUpModals();

tippy('svg.navigation-map a[data-tooltip-template]', {
  content(reference) {
    return reference.dataset.tooltipTemplate;
  },
  followCursor: true,
  allowHTML: true,
  duration: 100,
  plugins: [followCursor],
});
